<template>
    <div class="min-h-100 flex flex-column">
        <header id="navbar" class="fixed top-0 bg-black w-100 z-5" :class="{ 'nav-up': navUp }" style="user-select:none">
            <div class="flex h-100">
                <mq-layout mq="xs" class="w-100">
                    <HeaderSmall @showMenu="showMenu = $event" />
                </mq-layout>
                <mq-layout mq="sm+" class="w-100">
                    <HeaderLarge @showMenu="showMenu = $event" />
                </mq-layout>
            </div>
        </header>
        <slot></slot>
        <Overlay :show='showMenu' />
    </div>
</template>

<script>
import HeaderSmall from '@/components/header/HeaderSmall.vue';
import HeaderLarge from '@/components/header/HeaderLarge.vue';
import Overlay from '@/components/layout/Overlay.vue';

const DELTA = 20;
const NAVBAR_HEIGHT = 80;

export default {
    components: {
        HeaderSmall,
        HeaderLarge,
        Overlay
    },
    data() {
        return {
            lastScrollTop: 0,
            navUp: false,
            showMenu: false
        };
    },
    methods: {
        onScroll() {
            const st = document.documentElement.scrollTop;

            if (Math.abs(this.lastScrollTop - st) <= DELTA) return;

            this.navUp = st > this.lastScrollTop && st > NAVBAR_HEIGHT;
            this.lastScrollTop = st;
        }
    },
    created() {
        window.addEventListener('scroll', this.onScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    }
};
</script>

<style scoped>
#navbar {
    height: 80px;
    transition: top 0.2s ease-in-out;
}

.nav-up {
    top: -80px;
}
</style>
